import type { CaptureUploadSnapshot } from '@/lib/pcmAudioManager';
import { pcmToWav } from '@/lib/wavUtils';

/** The same capture offsets make pause, stop and retry uploads append once. */
export const uploadCaptureAudio = (
  id: string,
  snapshot: CaptureUploadSnapshot,
  wav = pcmToWav(snapshot.pcm, snapshot.sampleRate),
  options: { signal?: AbortSignal; kind?: 'standard' | 'interpreter' } = {}
) => {
  const body = new FormData();
  body.append('file', wav, 'complete.wav');
  body.append('capture_epoch_id', snapshot.captureEpochId);
  body.append('capture_start_sample', String(snapshot.captureStartSample));
  body.append('capture_end_sample', String(snapshot.captureEndSample));
  body.append('capture_sample_rate', String(snapshot.sampleRate));
  const path =
    options.kind === 'interpreter' ? `/api/interpreter/${id}/upload-audio` : `/api/sessions/${id}/upload-audio`;
  return fetch(path, { method: 'POST', credentials: 'include', body, signal: options.signal });
};
